<template>
  <div class="relative">
    <vs-navbar :collapse="false" color="#76bb46">
      <div slot="title">
        <vs-navbar-title>
<!--          <img src="@/assets/images/logo/logo.png" alt="login" class="mx-auto w-36 h-12">-->
        </vs-navbar-title>
      </div>

      <vs-navbar-item index="2">
        <i18n class="mx-2 py-1"/>
      </vs-navbar-item>

      <template v-if="showLogin">
        <vs-navbar-item index="3" v-if="this.$store.state.Auth.isUserLoggedIn()">
          <a href="#" class="mx-1" @click.stop="logout">
            Logout
          </a>
        </vs-navbar-item>
        <vs-navbar-item index="3" v-else>
          <a href="#" class="mx-1" @click.stop="$router.push({name: 'login'})">Login</a>
        </vs-navbar-item>
      </template>
    </vs-navbar>
  </div>
</template>

<script>
import I18n from '@/components/layouts/navbar/components/I18n.vue'

export default {
  components: {
    I18n,
  },
  name: "top-bar",
  props: {
    showLogin: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('Auth/logout').then(() => {
        this.$acl.change(['public']);
        this.$router.push({ name: 'login' });
      });
    }
  }
}
</script>

<style scoped>

</style>
